import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import auth from '../../features/auth/utils/mym';
import App from './App';
import {
  signIn as signInActionCreator,
  signOut as signOutActionCreator,
} from '../../features/auth/authSlice';

type Props = {
  signIn: (msisdn: string) => void;
  signOut: () => void;
};

const AppContainer: React.FC<Props> = (props) => {
  const { signIn, signOut } = props;

  useEffect(() => {
    const sessionId = auth.getSessionId();

    if (sessionId) {
      auth.login(
        sessionId,
        ({ msisdn }) => signIn(msisdn),
        () => signOut()
      );
    } else if (!sessionId && !auth.checkNotAuthorizedCookie()) {
      auth.check(
        () => {
          auth.getUser(
            ({ msisdn }) => signIn(msisdn),
            () => signOut()
          );
        },
        () => signOut()
      );
    } else {
      signOut();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <App />;
};

const dispatchProps = {
  signIn: signInActionCreator,
  signOut: signOutActionCreator,
};

export default connect(null, dispatchProps)(AppContainer);
